'use strict';

import angular from 'angular';

const inputCSS = {
  position: 'absolute',
  'z-index': 2,
  top: '0px',
  left: '0px',
  width: '100%',
  opacity: 0,
  'font-size': '100px'
};

export default function f($window, $q, utils, session, uploadPhoto) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      onUpload: '&',
      uploadUrl: '@',
      fileLimit: '='
    },
    link: function postLink($scope, $element, $attrs) {
      let counter = 0;
      const isFormDataSupported = ('FormData' in $window);
      const isMultipleUploadAllowed = $attrs.hasOwnProperty('multiple');
      let fileInput;

      function handleFormDataChange(event) {
        let files = event.target.files;

        if ($attrs.fileLimit) {
          files = Array.prototype.slice.call(files, 0, Math.min(files.length, $scope.fileLimit));
        }

        $scope.$apply(() => {
          $scope.onUpload({
            promises: uploadPhoto($scope.uploadUrl, files)
          });
          createFileInput();
        });
      }

      function getHiddenInput(name, value) {
        return '<input type="hidden" name="' +  name + '" value="' + value + '">';
      }

      function handleFormDataChangeViaIFrame() {
        const url = utils.getApiUrl($scope.uploadUrl) + '?type=iframe';
        let iFrame;
        let transportForm;

        counter++;

        iFrame = angular.element('<iframe src="" style="display:none;" name="uploadFrame-' + counter + '" frameborder="0"></iframe>');
        transportForm = angular.element('<form action="' + url + '" enctype="multipart/form-data" target="uploadFrame-' + counter + '" method="post"></form>');

        $element.parent().append(iFrame);
        iFrame.after(transportForm);

        const promise = new $q((resolve, reject) => {
          iFrame.on('load', () => {
            $scope.$apply(() => {
              let content;
              let photoData;

              try {
                content = iFrame.contents().find('body').text();
                photoData = JSON.parse(content);
                resolve(photoData);
              } catch (e) {
                reject();
              }

              iFrame.remove();
            });
          });
        });

        transportForm.append(fileInput);
        transportForm.append(getHiddenInput('accessToken', session.get().accessToken));
        transportForm[0].submit();
        transportForm.remove();

        createFileInput();

        $scope.$apply(function () {
          $scope.onUpload({
            promises: [promise]
          });
        });
      }

      function createFileInput() {
        if (fileInput) {
          fileInput.remove();
          fileInput = fileInput.clone();
        } else {
          fileInput = angular.element('<input type="file" name="photo" ' + (isMultipleUploadAllowed ? 'multiple' : '')+ '>').css(inputCSS);
        }

        $element.append(fileInput);

        if (isFormDataSupported) {
          fileInput.on('change', handleFormDataChange);
        } else {
          fileInput.on('change', handleFormDataChangeViaIFrame);
        }
      }

      $scope.$on('$destroy', function () {
        if (isFormDataSupported) {
          fileInput.off('change', handleFormDataChange);
        } else {
          fileInput.off('change', handleFormDataChangeViaIFrame);
        }
      });

      if ($element.css('position') !== 'absolute') {
        $element.css('position', 'relative');
      }

      createFileInput();
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/photo_upload_input.js